import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Button } from '@grandvisionhq/elements';

const CardButton = (_param)=>{
    var { 'data-t': dataT , onClick , children  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        'data-t',
        "onClick",
        "children"
    ]);
    return /*#__PURE__*/ React.createElement(Button, swcHelpers.extends({
        "data-t": dataT || 'card-button',
        className: "card-button",
        onClick: onClick,
        variant: "ghost"
    }, rest), children);
};

export { CardButton as default };
//# sourceMappingURL=CardButton.js.map
